export default () => {
  if ($('#KontaktEmpfaenger').length) {
    (($) => {
      $('#KontaktEmpfaenger').change(function () {
        $('.topics').hide();
        $('.topic').prop('checked', false);

        $('#topics_' + $(this).val()).show();
        // $("#rowKontaktBestellKundenNr").hide();
      });

      $("input[name$='topic']").click(function () {
        var showfield = $(this).attr('data-showField');

        if (showfield == '0') $('#rowKontaktBestellKundenNr').hide();
        else $('#rowKontaktBestellKundenNr').show();
      });

      $('button:reset').click(function () {
        $('.topics').hide();
        sel = document.getElementById('KontaktEmpfaenger');
        sel.selectedIndex = 0;
        return false;
      });
    })(jQuery);
  }

  if ($('._contactfom_sended').length) {
    $('._hidewhensended').hide();
  }
};
